export type jsonldData = Record<string, unknown>;

export type jsonldItem = Readonly<{
  id: string;
  dataSchema: jsonldData;
  dataQa?: string;
}>;

export function Jsonld({ id, dataSchema, dataQa }: jsonldItem): JSX.Element {
  return (
    <script
      id={id}
      data-qa={dataQa}
      type="application/ld+json"
      // JSON.stringify never escapes "<", so a "</script>" inside a string
      // value closes this script tag early and lets injected markup run.
      // Escaping it is enough: without a literal "<" nothing else here can
      // open a tag.
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(dataSchema).replace(/</g, "\\u003c"),
      }}
    />
  );
}
